// reducers/processQueueSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  queue: {},
};

const processQueueSlice = createSlice({
  name: "processQueue",
  initialState,
  reducers: {
    resetQueue: (state) => {
      state.queue = {};
    },
    popQueue: (state, action) => {
      const { key } = action.payload;
      delete state.queue[key];
    },
    pushQueue: (state, action) => {
      const { key, value } = action.payload;
      state.queue[key] = value;
    },
  },
});

export const { resetQueue, popQueue, pushQueue } = processQueueSlice.actions;
export default processQueueSlice.reducer;
